export default "__VITE_ASSET__C2k41Y3O__"